// Single place to resolve map provider env keys.
// Supports both the legacy CRA-style names and the new Vite names.

const viteEnv = (typeof import.meta !== "undefined" && import.meta.env) || {};
const procEnv = (typeof process !== "undefined" && process.env) || {};

export const GOOGLE_MAPS_API_KEY =
  viteEnv.VITE_GOOGLE_MAPS_API ||
  procEnv.REACT_APP_GOOGLE_MAPS_API ||
  "";

export const MAPTILER_API_KEY =
  viteEnv.VITE_MAPTILER_API_KEY ||
  procEnv.REACT_APP_MAPTILER_API_KEY ||
  "";

// AdvancedMarker only renders on a map that has a Map ID (Cloud Console >
// Map Management). DEMO_MAP_ID is Google's shared ID for development; set
// VITE_GOOGLE_MAPS_MAP_ID in production.
export const GOOGLE_MAPS_MAP_ID =
  viteEnv.VITE_GOOGLE_MAPS_MAP_ID ||
  procEnv.REACT_APP_GOOGLE_MAPS_MAP_ID ||
  "DEMO_MAP_ID";

export const hasGoogleKey = Boolean(GOOGLE_MAPS_API_KEY);
export const hasMaptilerKey = Boolean(MAPTILER_API_KEY);
